<template lang="pug">
    .col-span-6.vue-select
        label.block.text-sm.font-medium.text-gray-700(
            :for="'field_' + parameter.id"
            :class="{ 'required': parameter['required'] }")
            | {{ parameter.name }}
        v-select.block.text-sm.font-medium.text-gray-700(
            :id="'field_' + parameter.id"
            v-model="selected"
            :options="options"
            label="text"
            @input="handleChange"
            :class="{ 'form-error': error }"
        )
        p.mt-2.p-1.rounded.text-sm.text-red-500.bg-gray-100(v-if='error')
            | {{ error.message || 'Поле обязательно для заполнения' }}
</template>

<script>

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
    name: 'ItemFormGroupParameterSelect',

    components: {
        'v-select': vSelect,
    },

    props: {
        parameter: {
            type: Object,
        },

        value: {
            type: [String, Number],
        },

        error: {
            type: [Object, Boolean],
        },
    },

    data () {
        return {
            options: [],
            selected: (this.value) ? this.value : {id: false, text: 'Выберите значение'},
        }
    },

    computed: {
        extra() {
            return this.parameter.hasOwnProperty('extra_serialized') ? this.parameter.extra_serialized : false
        },
    },

    watch: {
        extra: {
            handler(newValue) {
                if (newValue) {
                    this.options = newValue
                }
            },
        },

        value: {
            handler(newValue) {
                if (newValue) {
                    this.selected = this.value
                }
            },
        },
    },

    mounted() {
        if (this.extra) {
            // this.options = (typeof this.extra === "string") ? JSON.parse(this.extra) : this.extra
            this.options =  this.extra
        }
    },

    methods: {
        handleChange(selectedObject) {
            if (selectedObject) {
                this.$emit('input', selectedObject.id)
            } else {
                // todo: make a default select value to separate file with export
                this.selected = {id: false, text: 'Выберите значение'}
                this.$emit('input', false)
            }
        },
    },

}
</script>

<style lang="sass">
.vue-select
    .form-error
        border: none
        .vs__dropdown-toggle
            --tw-border-opacity: 1
            border-color: rgba(248, 113, 113, var(--tw-border-opacity))
            border-width: 2px
    .vs__dropdown-toggle
        height: 40px
</style>
